import React, { Component } from 'react';
import { ToggleSmall, Modal, Checkbox } from 'carbon-components-react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import NumberFormat from "react-number-format";
import { Breadcrumb, Card } from '../../../components';
import { validaCnpj } from "../../../lib/validations";

import {
  insertDmService,
  getByDmService,
  updateDmService,
  deleteDmService,
  getDmService
} from '../../../services/Api';

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ativo: false,
      openMdDelete: false,
      cidadeId: 0,
      grupos: []
    };
  }

  componentWillMount = async () => {
    await this.getItem();
    await this.getGroups();
  }

  getItem = async () => {
    const { match } = this.props;
    const urlId = match.params && match.params.id;
    try {
      let data = null;
      let checkAll = true;
      if (urlId > 0) {
        checkAll = false;
        data = await getByDmService('/Fornecedor', urlId);
      }

      const estadoId = data ? data.cidade ? data.cidade.estado.id : 0 : 0;
      const cidadeId = data ? data.cidade ? data.cidade.id : 0 : 0;

      this.setState({ ...data, cidadeId, estadoId, checkAll }, async () => {
        await this.getEstados(estadoId);
        await this.getCidades();
      });
    } catch (e) {
      if (e.message) toast.error(e.message);
      else toast.error('Ocorreu um erro ao carregar os dados');
    }
  };

  getGroups = async () => {
    const { grupos } = this.state;
    const list = await getDmService('/ProdutoCategoria/GetByTipo/?tipo=1')
    const groups = list.map(item => ({ id: item.id, label: item.nome, checked: grupos && grupos.indexOf(item.id) > -1 }));
    this.setState({ groups })
  }

  getEstados = async (selectedId) => {
    const list = await getByDmService('/Estado/Get', '');
    const estados = list.map(item => ({ id: item.id, label: item.nome }));
    let selectedState = estados.find(el => el.id === selectedId);
    const idxFirst = 0;
    if (selectedState === null && estados && estados.length === 1) {
      selectedState = estados[idxFirst]
    }
    this.setState({ selectedState, estados });
  };

  getCidades = async () => {
    const { estadoId, cidadeId } = this.state;
    const list = await getByDmService('/Cidade/GetByEstado', estadoId);
    const cidades = list.map(item => ({ id: item.id, label: item.nome }));
    let selectedCity = cidades.find(el => el.id === cidadeId);
    const idxFirst = 0
    if (selectedCity == null && cidades && cidades.length === 1) {
      selectedCity = cidades[idxFirst];
    }
    this.setState({
      selectedCity,
      cidades,
      cidadeId: selectedCity ? selectedCity.id : 0
    });
  };

  onToogle = () => {
    const { match } = this.props;
    const { ativo } = this.state;
    const urlId = match.params && match.params.id;
    this.setState(
      prevState => ({
        ativo: !prevState.ativo
      }),
      async () => {
        try {
          await updateDmService(`/Fornecedor/AlteraStatus`, urlId, null);
        } catch (e) {
          this.setState({ ativo });
          toast.warn("Ocorreu uma falha ao tentar trocar o status do item")
        }
      }
    );
  };

  onChangeText = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onChangeCnpj = event => {
    if (validaCnpj(event.target.value)) event.target.setCustomValidity("");
    else event.target.setCustomValidity("O CNPJ informado é inválido.");
    this.setState({ [event.target.name]: event.target.value });
  }


  onChangeState = obj => {
    this.setState({
      selectedState: { id: obj.id, label: obj.label },
      estadoId: obj.id
    }, async () => {
      this.getCidades();
    });
  }

  onChangeCity = obj => {
    this.setState({
      selectedCity: { id: obj.id, label: obj.label },
      cidadeId: obj.id
    })
  }

  onChangeGroupCheck = (val, id) => {
    const { grupos } = this.state;
    const _id = parseInt(id, 10);
    if (grupos.indexOf(_id) > -1 && !val) {
      grupos.pop(_id);
    } else if (grupos.indexOf(_id) === -1 && val) {
      grupos.push(_id);
    }
    this.setState({ grupos });
  };

  saveItem = async e => {
    e.preventDefault();
    const { cnpj, grupos, complemento, email, endereco, nomeFantasia, numero, razaoSocial, telefone, cidadeId } = this.state;
    const { match, history } = this.props;
    const urlId = match.params && match.params.id;
    const urlEdit = `/Fornecedor/`;

    const formData = {
      CNPJ: cnpj,
      Cidade: { id: cidadeId },
      Grupos: grupos,
      complemento,
      email,
      endereco,
      nomeFantasia,
      numero,
      razaoSocial,
      telefone
    };

    try {
      if (urlId && urlId > 0) {
        await updateDmService(urlEdit, urlId, formData);
        history.goBack()
        toast.success('Edição realizada com sucesso.');
      } else {
        await insertDmService(urlEdit, formData);
        history.goBack()
        toast.success('Nome salvo com sucesso.');
      }
    } catch (error) {
      this.errorHandler(error);
    }
  };

  errorHandler = err => {
    console.log("err", err)
    if (err.error && typeof err.error.response.data.modelState !== 'undefined') {
      let error = 'Ocorreu o seguinte erro: ';

      const erros = err.error.response.data.modelState;
      for (const p in erros) {
        let name = p.replace('model.', '');
        name = name[0].toUpperCase() + name.slice(1);
        error += `${erros[p]}; `;
      }
      toast.warning(error.trim());
    } if (err.message)
      toast.error(err.message);
    else {
      toast.error('Ocorreu um erro ao salvar os dados, tente novamente mais tarde');
    }
  };

  modalDelete = () => {
    this.setState(prevState => ({
      openMdDelete: !prevState.openMdDelete
    }));
  }


  delete = async () => {
    const { match, history } = this.props;
    const urlId = match.params && match.params.id;

    try {
      await deleteDmService("/Fornecedor/", urlId);
      toast.success("Item excluído com sucesso.");
      history.goBack();
    } catch (error) {
      toast.error("Um erro inesperado ocorreu ao tentar deletar");
    }
  }


  render() {
    const {
      ativo,
      openMdDelete,
      nomeFantasia,
      razaoSocial,
      cnpj,
      complemento,
      email,
      endereco,
      numero,
      telefone,
      groups,
      cidades,
      estados,
      selectedCity,
      selectedState,
      checkAll,
    } = this.state;

    const { history, match } = this.props;
    const urlId = match.params && match.params.id;
    const titleBread = urlId > 1 ? "Editar " : "Cadastrar "
    return (
      <div>
        <Breadcrumb
          title={`${titleBread} Fornecedor`}
          description="Gerencie fornecedores."
          renderRight={(urlId <= 0 ? () => { } : () => (
            <div className="flex v-sm-margin">
              <label
                htmlFor="toogle-active"
                className={`${ativo ? 'text-info ' : 'text-warning'
                  } label-toogle-active`}
              >
                {ativo ? 'Ativo' : 'Inativo'}
              </label>
              <ToggleSmall
                id="toogle-active"
                className="toogle-active"
                toggled={ativo}
                ariaLabel="Ativo"
                onClick={() => this.onToogle()}
              />
              <button
                className="bx--btn btn-primary-outlined h-sm-margin"
                type="button"
                onClick={() => this.modalDelete()}
              >
                Remover
              </button>
            </div>
          ))()}
          renderLeft={(() => (
            <div
              className="breadcrumb-left-actions pointer"
              onClick={() => history.goBack()}
            >
              <svg width="16" height="14" viewBox="0 0 16 14">
                <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
              </svg>
            </div>
          ))()}
        />


        <Card className="center-box">
          <form
            onSubmit={this.saveItem}
          >
            <div className="mg-left-20 mg-top-20">
              <div className="bx--row">
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">
                    Razão Social
                    <span className="required-asterisk"> *</span>
                  </label>
                  <input
                    type="text"
                    className="bx--text-input"
                    required
                    placeholder="Razão Social"
                    name="razaoSocial"
                    value={razaoSocial}
                    onChange={this.onChangeText}
                  />
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">
                    Nome fantasia
                    <span className="required-asterisk"> *</span>
                  </label>
                  <input
                    type="text"
                    className="bx--text-input"
                    required
                    placeholder="Nome fantasia"
                    name="nomeFantasia"
                    value={nomeFantasia}
                    onChange={this.onChangeText}
                  />
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">
                    CNPJ
                    <span className="required-asterisk"> *</span>
                  </label>
                  <NumberFormat
                    className="bx--text-input"
                    format="##.###.###/####-##"
                    required
                    placeholder="cnpj"
                    name="cnpj"
                    value={cnpj}
                    onChange={this.onChangeCnpj}
                  />
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">
                    Telefone
                    <span className="required-asterisk"> *</span>
                  </label>
                  <NumberFormat
                    className="bx--text-input"
                    format="(##) ####.#####"
                    required
                    placeholder="telefone"
                    name="telefone"
                    value={telefone}
                    onChange={this.onChangeText}
                  />
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">
                    E-mail
                    <span className="required-asterisk"> *</span>
                  </label>
                  <input
                    type="email"
                    className="bx--text-input"
                    required
                    placeholder="E-mail"
                    name="email"
                    value={email}
                    onChange={this.onChangeText}
                  />
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">UF</label>
                  <Select
                    className="search-dm"
                    name="cidade"
                    required
                    options={estados}
                    value={selectedState}
                    onChange={this.onChangeState}
                    placeholder="UF"
                    isClearable={false}
                    isSearchable
                  />
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">Cidade</label>
                  <Select
                    className="search-dm"
                    name="cidade"
                    required
                    options={cidades}
                    value={selectedCity}
                    onChange={this.onChangeCity}
                    placeholder="Cidade"
                    isClearable={false}
                    isSearchable
                  />
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">
                    Endereço
                    <span className="required-asterisk"> *</span>
                  </label>
                  <input
                    type="text"
                    className="bx--text-input"
                    required
                    placeholder="Endereço"
                    name="endereco"
                    value={endereco}
                    onChange={this.onChangeText}
                  />
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">
                    Número
                    <span className="required-asterisk"> *</span>
                  </label>
                  <input
                    type="text"
                    className="bx--text-input"
                    required
                    placeholder="Número"
                    name="numero"
                    value={numero}
                    onChange={this.onChangeText}
                  />
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">
                    Complemento
                  </label>
                  <input
                    type="text"
                    className="bx--text-input"
                    placeholder="Complemento"
                    name="complemento"
                    value={complemento}
                    onChange={this.onChangeText}
                  />
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-xs-12 bx--col-md-8 v-md-margin">
                  <label className="bx--label"> Quais grupos de produtos ele atende? </label>
                  <div className="clearfix" />
                  <div className="bx--row">
                    {groups && groups.map(obj => (
                      <div className="bx--col-xs-12 bx--col-md-6" key={`divCategorias${obj.id}`}>
                        <Checkbox
                          labelText={obj.label}
                          id={` ${obj.id}`}
                          name="aplicacao"
                          defaultChecked={obj.checked || checkAll}
                          onChange={this.onChangeGroupCheck}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="bx--row mg-left-20">
                <div className="bx--col-xs-12 v-md-margin ">
                  <button
                    tabIndex="0"
                    className="bx--btn btn-secondary-color"
                    type="submit"
                  >
                    Salvar
                  </button>
                  <button
                    tabIndex="0"
                    className="h-sm-margin bx--btn btn-secondary-outlined"
                    type="button"
                    onClick={() => history.goBack()}
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </form>
        </Card>

        <Modal
          className="some-class"
          open={openMdDelete}
          modalHeading="Remover Item"
          primaryButtonText="Tenho certeza"
          secondaryButtonText="Cancelar"
          iconDescription="Cancelar e fecchar"
          onRequestClose={() => this.modalDelete()}
          onRequestSubmit={() => this.delete()}
        >
          <p className="bx--modal-content__text">
            Você tem certeza que deseja deletar este item?
          </p>
        </Modal>
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/screens/admin/Fornecedor/Edit.js